/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type ProprietaMisurataTypeIcona =
  (typeof ProprietaMisurataTypeIcona)[keyof typeof ProprietaMisurataTypeIcona];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProprietaMisurataTypeIcona = {
  Rms: "Rms",
  Fft: "Fft",
  Trend: "Trend",
  Air: "Air",
  Unknown: "Unknown",
  Temperatura: "Temperatura",
  Particelle: "Particelle",
  Pressione: "Pressione",
  Umidita: "Umidita",
  PotenzaMotore: "PotenzaMotore",
  Portata: "Portata",
  Acidita: "Acidita",
  Ph: "Ph",
  concentrazioneRifrattometrica: "concentrazioneRifrattometrica",
  Saturazione: "Saturazione",
  Conducibilita: "Conducibilita",
} as const;
